import { TruckIcon } from 'lucide-react';

import { MarqueeText } from './MarqueeText';

interface ShippingTipProps {
  /** 发货日期，支持 Date 或可解析的字符串 */
  shippingDate: Date | string;
}

// 独立的发货日期提示组件，可复用于其他位置
export function ShippingTip({ shippingDate }: ShippingTipProps) {
  const parsed = shippingDate instanceof Date ? shippingDate : new Date(shippingDate);
  if (Number.isNaN(parsed.getTime())) {
    return (
      <span className="flex items-center justify-center w-full min-w-0">
        <span className="inline-flex items-center gap-2 leading-none min-w-0 w-full">
          <TruckIcon className="w-4 h-4 shrink-0 text-zinc-500" />
          <span className="flex-1 min-w-0">
            <MarqueeText className="text-[11px] font-medium text-zinc-600 uppercase tracking-wider">
              Spedizione prossima
            </MarqueeText>
          </span>
        </span>
      </span>
    );
  }

  const weekdayRaw = parsed.toLocaleDateString('it-IT', { weekday: 'long' });
  const weekday = weekdayRaw.charAt(0).toUpperCase() + weekdayRaw.slice(1);

  const day = parsed.getDate().toString().padStart(2, '0');
  const monthRaw = parsed.toLocaleDateString('it-IT', { month: 'short' });
  const month = (monthRaw.charAt(0).toUpperCase() + monthRaw.slice(1)).replace('.', '');

  return (
    <span className="flex items-center justify-center w-full min-w-0">
      <span className="inline-flex items-center gap-2 leading-none min-w-0 w-full">
        <TruckIcon className="w-4 h-4 shrink-0 text-primary/80" />
        <span className="flex-1 min-w-0">
          <MarqueeText className="text-sm font-medium text-zinc-700">
            Spedizione stimata: <span className="font-bold text-zinc-900">{day} {month}</span> ({weekday})
          </MarqueeText>
        </span>
      </span>
    </span>
  );
}
